import { Link } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import OptimizedImage from "../components/OptimizedImage";
import logo from "../assets/images/newLogoNoBg.png";

const StyledContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "80vh",
  textAlign: "center",
  padding: theme.spacing(4),
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  width: 200,
  height: 200,
  margin: "0 auto 2rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& img": {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "100%",
    objectFit: "contain",
  },
  [theme.breakpoints.down("sm")]: {
    width: 150,
    height: 150,
    fontSize: "3rem",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1, 1),
  padding: "0.8rem 1.8rem",
  borderRadius: "50px",
  fontWeight: 600,
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: theme.shadows[4],
  },
}));

const ButtonContainer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "1rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    width: "100%",
    "& > *": {
      width: "100%",
      margin: theme.spacing(0.5, 0),
    },
  },
}));

const NotFound = () => {
  return (
    <StyledContainer maxWidth="md">
      <LogoContainer>
        <OptimizedImage
          src={logo}
          alt="Logo Ilaria Stumpo"
          width={200}
          height={200}
          loading="eager"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </LogoContainer>

      <Typography variant="h3" component="h1" gutterBottom color="primary">
        Ops! Pagina non trovata
      </Typography>

      <Typography variant="body1" color="textSecondary" paragraph>
        La pagina che stai cercando sembra essere svanita nell&apos;etere, proprio come i pensieri durante la meditazione.
      </Typography>

      <ButtonContainer>
        <StyledButton variant="contained" color="primary" component={Link} to="/">
          Torna alla Home
        </StyledButton>

        <StyledButton variant="outlined" color="primary" component={Link} to="/blog">
          Esplora il Blog
        </StyledButton>
      </ButtonContainer>

      <Typography variant="body2" color="textSecondary" sx={{ mt: 4 }}>
        Se pensi che ci sia un errore,{" "}
        <Link
          to="/contatti"
          style={{
            color: "inherit",
            textDecoration: "none",
            fontWeight: 600,
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          contattami
        </Link>
        .
      </Typography>
    </StyledContainer>
  );
};

export default NotFound;
